// api
export const API_MONITORING =
  '/platformmonitoringdashboard/platformmonitoringurls';

// redux
export const MONITORING_STORE = 'monitoring';
export const MONITORING_STORE_URL = 'monitoringUrlList';
